import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getFrontTranslations = async () => {
  const { data } = await IBModuleApi.get(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/translationsfront`
  );

  return data;
};

export const getTranslations = async () => {
  const { data } = await IBModuleApi.get(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/admin/translations`
  );

  return data;
};

export const createTranslation = async (createInfo: any) => {
  const { data } = await IBModuleApi.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/admin/translation`,
    createInfo
  );

  return data;
};

export const createTranslations = async (createInfo: any) => {
  const { data } = await IBModuleApi.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/admin/translations`,
    createInfo
  );

  return data;
};

export const updateTranslation = async (updateInfo: any) => {
  const { data } = await IBModuleApi.put(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/admin/translation`,
    updateInfo
  );

  return data;
};

export const deleteTranslation = async (translation: number) => {
  const { data } = await IBModuleApi.delete(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/admin/translation/${translation}`
  );

  return data;
};

export const exportTranslations = async (info: any) => {
  const { filtersInfo, filename } = info;
  const { data } = await IBModuleApi.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/admin/translations/export`,
    filtersInfo,
    {
      responseType: "blob",
    }
  );

  const href = URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = href;
  link.setAttribute("download", `${filename}.csv`);
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};

export const importTranslations = async (info: any) => {
  const { data } = await IBModuleApi.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/admin/translations/import`,
    info
  );

  return data;
};
